import { EventAvailable } from '@mui/icons-material';
import { guard } from '../RequirePermission';
import { ReservationsList } from './ReservationsList';
import { ReservationsShow } from './ReservationsShow';
import { ReservationsEdit } from './ReservationsEdit';
import { CalendarView } from './CalendarView';

export { ReservationsList } from './ReservationsList';
export { ReservationsShow } from './ReservationsShow';
export { ReservationsEdit } from './ReservationsEdit';
export { CalendarView as ReservationsCalendarView } from './CalendarView';
export { ReservationStatusChip } from './ReservationsList';

export const reservationsResource = {
    list: guard('reservations:read:all', ReservationsList),
    show: guard('reservations:read:all', ReservationsShow),
    edit: guard('reservations:write:all', ReservationsEdit),
    icon: EventAvailable,
    recordRepresentation: 'id',
    meta: { permissions: ['reservations:read:all', 'reservations:write:all'] as const },
};
